// TODO: Remove once mobile support is fully implemented.
export function isMobileDevice(): boolean {
  const uaMatch = /Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(
    navigator.userAgent
  );
  const viewportMatch = window.innerWidth < 768;
  return uaMatch || viewportMatch;
}
